// @flow

import React, { useCallback } from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '@riseart/common';
import { VisuallySimilarIcon } from '@riseart/icons';

type Props = {
  url: ?string,
  className?: string,
  title?: string,
  showText?: boolean,
  onClick?: Function,
};

/**
 * SimilarArtworksLink
 *
 * @param {Props} props
 * @returns {Node}
 */
export const SimilarArtworksLink = ({
  url,
  className = null,
  title,
  showText = false,
  onClick,
}: Props): Node => {
  const handleClick = useCallback(
    (params: Object) => {
      window.scrollTo(0, 0);

      if (typeof onClick === 'function') {
        onClick(params);
      }
    },
    [onClick],
  );

  return url ? (
    <FormattedMessage id="components.art.findSimilarArtworks">
      {(label: string) => (
        <Link
          obfuscate
          rel="nofollow"
          {...(className ? { className } : null)}
          to={url}
          title={title || label}
          onClick={handleClick}
        >
          <VisuallySimilarIcon />
          {showText ? <span>{title}</span> : null}
        </Link>
      )}
    </FormattedMessage>
  ) : null;
};
